


























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Account } from "../models/account";
import loader from "@/components/loader.vue";
import { Address } from "../models/address";

import { NSLog } from "@/helpers/log";
const log = NSLog("components/AddressForm");

@Component({
  components: {
    loader
  }
})
export default class AddressForm extends Vue {
  @Prop() public address?: Address;
  get addr() {
    return this.address || {};
  }
}
